import React, { useState } from "react";
import { FaFlag, FaUsers } from "react-icons/fa";

/**
 * @file Modules.js
 * @description Page for managing Feature Flags and global module availability.
 */
export default function Modules() { // Feature Flags
  const [flags, setFlags] = useState([
    { id: 1, name: "New Workflow Editor", key: "new_editor_v2", enabled: true, rollout: 50, scope: "Beta Tenants" },
    { id: 2, name: "AI Agent Debugger", key: "ai_debugger", enabled: false, rollout: 0, scope: "Internal" },
    { id: 3, name: "Stripe Billing V2", key: "billing_v2", enabled: true, rollout: 100, scope: "All Tenants" },
  ]);

  const toggleFlag = (id) => {
    setFlags(flags.map(f => f.id === id ? { ...f, enabled: !f.enabled } : f));
  };

  return (
    <div className="p-4 bg-light min-vh-100">
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Feature Flags</h4>
        <p className="text-muted small">Manage global module availability and feature rollouts.</p>
      </div>

      {/* KPIS */}
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center gap-3">
              <div className="p-3 bg-primary-subtle text-primary rounded"><FaFlag size={20} /></div>
              <div>
                <div className="text-muted small fw-bold text-uppercase">Flags Enabled</div>
                <h4 className="fw-bold mb-0">{flags.filter(f => f.enabled).length} / {flags.length}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card border-0 shadow-sm p-3">
            <div className="d-flex align-items-center gap-3">
              <div className="p-3 bg-success-subtle text-success rounded"><FaUsers size={20} /></div>
              <div>
                <div className="text-muted small fw-bold text-uppercase">Tenants Affected</div>
                <h4 className="fw-bold mb-0">142</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FLAGS TABLE */}
      <div className="card border-0 shadow-sm rounded-3">
        <table className="table table-hover align-middle mb-0">
          <thead className="bg-light">
            <tr>
              <th className="ps-4 py-3">Feature Name</th>
              <th>Key</th>
              <th>Status</th>
              <th>Rollout %</th>
              <th className="pe-4 text-end">Scope</th>
            </tr>
          </thead>
          <tbody>
            {flags.map(flag => (
              <tr key={flag.id}>
                <td className="ps-4 fw-medium">{flag.name}</td>
                <td className="font-monospace text-muted small">{flag.key}</td>
                <td>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={flag.enabled}
                      onChange={() => toggleFlag(flag.id)}
                      style={{ cursor: "pointer" }}
                    />
                    <label className="form-check-label ms-2 small">{flag.enabled ? "Enabled" : "Disabled"}</label>
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-center gap-2" style={{ maxWidth: "150px" }}>
                    <div className="progress flex-grow-1" style={{ height: "6px" }}>
                      <div className="progress-bar" style={{ width: `${flag.rollout}%` }}></div>
                    </div>
                    <span className="small text-muted">{flag.rollout}%</span>
                  </div>
                </td>
                <td className="pe-4 text-end">
                  <span className="badge bg-light text-dark border">{flag.scope}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}